'use strict';

let sdkPromise;
let sdkUrl;
let nextId = 0;
let componentTypes = ['PersonalArea', 'AccountInfoBanner', 'AccountInfoMenu', 'OrderThankYou'];

function loadSDK(url) {
	if (sdkPromise) {
		return url === sdkUrl ? sdkPromise : Promise.reject(new Error('Conflicting loyalty SDK origins'));
	}
	sdkUrl = url;
	sdkPromise = new Promise(function (resolve, reject) {
		let script = document.createElement('script');
		let timer = window.setTimeout(function () {
			script.onload = null;
			script.onerror = null;
			reject(new Error('Loyalty SDK timed out'));
		}, 15000);
		script.src = url;
		script.async = true;
		script.onload = function () {
			window.clearTimeout(timer);
			if (window.yxpLvzSDK) resolve(window.yxpLvzSDK);
			else reject(new Error('Loyalty SDK unavailable'));
		};
		script.onerror = function () {
			window.clearTimeout(timer);
			reject(new Error('Loyalty SDK failed to load'));
		};
		document.head.appendChild(script);
	});
	return sdkPromise;
}

/** Mount each server-authorized container once, including multiple widgets on one page. */
function init() {
	Array.prototype.forEach.call(document.querySelectorAll('[data-loyalty-component]'), function (element) {
		if (element.getAttribute('data-loyalty-state')) return;
		let type = element.getAttribute('data-loyalty-component');
		let url = element.getAttribute('data-loyalty-sdk');
		let orderDataRaw = element.getAttribute('data-loyalty-order-data');
		if (
			componentTypes.indexOf(type) === -1 ||
			!/^https:\/\/[a-z0-9](?:[a-z0-9.-]*[a-z0-9])?(?::[0-9]{1,5})?\/fe-web\/js\/lvz_sdk\.js$/i.test(url)
		)
			return;

		element.setAttribute('data-loyalty-state', 'loading');
		element.setAttribute('aria-busy', 'true');
		// Dedicated SDK target keeps generated selectors safe and unique.
		let target = document.createElement('div');
		do {
			nextId += 1;
			target.id = 'loyalty-sdk-' + nextId;
		} while (document.getElementById(target.id));
		element.appendChild(target);

		loadSDK(url)
			.then(function (sdk) {
				if (typeof sdk[type] !== 'function') throw new Error('Loyalty component unavailable');
				let orderData;
				if (orderDataRaw) {
					try {
						orderData = JSON.parse(orderDataRaw);
					} catch (e) {
						orderData = undefined;
					}
				}
				let instance = orderData !== undefined
					? new sdk[type]('#' + target.id, orderData)
					: new sdk[type]('#' + target.id);
				element.loyaltyInstance = instance;
				element.setAttribute('data-loyalty-state', 'ready');
				element.setAttribute('aria-busy', 'false');
			})
			.catch(function () {
				element.setAttribute('data-loyalty-state', 'error');
				element.setAttribute('aria-busy', 'false');
				element.hidden = true;
			});
	});
}

module.exports = { init: init };
